// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b9d209ed","182":"28de789d","247":"8623d9a1","422":"09854d9b","472":"b787ef90","551":"e191d2d7","627":"bf614646","653":"f52cd754","828":"096bc2b1","842":"84e10af8","867":"ca831d24","923":"a90a4b53","938":"50db959f","965":"4d0afdd9"}[chunkId] + ".chunk.js";
};